var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/status/components/card.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import classnames from 'clsx';
import { List as ImmutableList } from 'immutable';
import React, { useState, useEffect } from 'react';
import Blurhash from 'soapbox/components/blurhash';
import Icon from 'soapbox/components/icon';
import { HStack, Stack, Text } from 'soapbox/components/ui';
import { useSettings } from 'soapbox/hooks';
import { normalizeAttachment } from 'soapbox/normalizers';
import { addAutoPlay } from 'soapbox/utils/media';

const trim = (text, len) => {
  const cut = text.indexOf(' ', len);

  if (cut === -1) {
    return text;
  }

  return text.substring(0, cut) + (text.length > len ? '…' : '');
};

const Card = _ref => {
  let {
    card,
    defaultWidth = 467,
    maxTitle = 120,
    maxDescription = 200,
    compact = false,
    cacheWidth,
    onOpenMedia,
    horizontal
  } = _ref;
  const settings = useSettings();
  const shouldAutoPlayVideo = settings.get('autoPlayVideo');
  const [width, setWidth] = useState(defaultWidth);
  const [embedded, setEmbedded] = useState(false);
  useEffect(() => {
    setEmbedded(false);
  }, [card.url]);
  const trimmedTitle = trim(card.title, maxTitle);
  const trimmedDescription = trim(card.description, maxDescription);

  const handlePhotoClick = () => {
    const attachment = normalizeAttachment({
      type: 'image',
      url: card.embed_url,
      description: trimmedTitle,
      meta: {
        original: {
          width: card.width,
          height: card.height
        }
      }
    });
    onOpenMedia(ImmutableList([attachment]), 0);
  };

  const handleEmbedClick = e => {
    e.stopPropagation();

    if (card.type === 'photo') {
      handlePhotoClick();
    } else {
      setEmbedded(true);
    }
  };

  const setRef = c => {
    if (c) {
      if (cacheWidth) {
        cacheWidth(c.offsetWidth);
      }

      setWidth(c.offsetWidth);
    }
  };

  const renderVideo = () => {
    const content = {
      __html: shouldAutoPlayVideo ? addAutoPlay(card.html) : card.html
    };
    const ratio = getRatio(card);
    const height = width / ratio;
    return /*#__PURE__*/React.createElement("div", {
      ref: setRef,
      className: "status-card__image status-card-video",
      dangerouslySetInnerHTML: content,
      style: {
        height
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 100,
        columnNumber: 7
      }
    });
  };

  const getRatio = card => {
    const ratio = card.width / card.height || 16 / 9; // Constrain to a sane limit
    // https://en.wikipedia.org/wiki/Aspect_ratio_(image)

    return Math.min(Math.max(9 / 16, ratio), 4);
  };

  const interactive = card.type !== 'link';
  horizontal = typeof horizontal === 'boolean' ? horizontal : interactive || embedded;
  const className = classnames('status-card', {
    horizontal,
    compact,
    interactive
  }, "status-card--".concat(card.type));
  const ratio = getRatio(card);
  const height = compact && !embedded ? width / (16 / 9) : width / ratio;
  const title = interactive ? /*#__PURE__*/React.createElement("a", {
    onClick: e => e.stopPropagation(),
    href: card.url,
    title: trimmedTitle,
    rel: "noopener",
    target: "_blank",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 7
    }
  }, trimmedTitle)) : /*#__PURE__*/React.createElement("span", {
    title: trimmedTitle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 5
    }
  }, trimmedTitle);
  const description = /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    className: "flex-1 overflow-hidden p-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 5
    }
  }, trimmedTitle && /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 9
    }
  }, title), trimmedDescription && /*#__PURE__*/React.createElement(Text, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 143,
      columnNumber: 9
    }
  }, trimmedDescription), /*#__PURE__*/React.createElement(HStack, {
    space: 1,
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 145,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/link.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 9
    }
  }, card.provider_name)));
  let embed = '';
  const canvas = /*#__PURE__*/React.createElement(Blurhash, {
    className: "absolute w-full h-full inset-0 -z-10",
    hash: card.blurhash,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 5
    }
  });
  const thumbnail = /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: "url(".concat(card.image, ")"),
      width: horizontal ? width : undefined,
      height: horizontal ? height : undefined
    },
    className: "status-card__image-image",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 166,
      columnNumber: 5
    }
  });

  if (interactive) {
    if (embedded) {
      embed = renderVideo();
    } else {
      let iconVariant = require('@tabler/icons/player-play.svg');

      if (card.type === 'photo') {
        iconVariant = require('@tabler/icons/zoom-in.svg');
      }

      embed = /*#__PURE__*/React.createElement("div", {
        className: "status-card__image",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 187,
          columnNumber: 9
        }
      }, canvas, thumbnail, /*#__PURE__*/React.createElement("div", {
        className: "absolute inset-0 flex items-center justify-center",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 191,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-gray-500/90 dark:bg-gray-700/90 shadow-md rounded-full px-4 py-3 flex items-center justify-center",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 192,
          columnNumber: 13
        }
      }, /*#__PURE__*/React.createElement(HStack, {
        space: 3,
        alignItems: "center",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 193,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement("button", {
        onClick: handleEmbedClick,
        className: "appearance-none text-gray-700 dark:text-gray-500 hover:text-gray-900 dark:hover:text-gray-100",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 194,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        src: iconVariant,
        className: "w-6 h-6 text-inherit",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 195,
          columnNumber: 19
        }
      })), horizontal && /*#__PURE__*/React.createElement("a", {
        onClick: e => e.stopPropagation(),
        href: card.url,
        target: "_blank",
        rel: "noopener",
        className: "text-gray-700 dark:text-gray-500 hover:text-gray-900 dark:hover:text-gray-100",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 202,
          columnNumber: 19
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        src: require('@tabler/icons/external-link.svg'),
        className: "w-6 h-6 text-inherit",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 209,
          columnNumber: 21
        }
      }))))));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: className,
      ref: setRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 223,
        columnNumber: 7
      }
    }, embed, description);
  } else if (card.image) {
    embed = /*#__PURE__*/React.createElement("div", {
      className: classnames('status-card__image', 'w-full rounded-l md:w-auto md:h-auto flex-none md:flex-auto', {
        'h-auto': horizontal,
        'h-[200px]': !horizontal
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 230,
        columnNumber: 7
      }
    }, canvas, thumbnail);
  } else {
    embed = /*#__PURE__*/React.createElement("div", {
      className: "status-card__image status-card__image--empty",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 245,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: require('@tabler/icons/file-text.svg'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 246,
        columnNumber: 9
      }
    }));
  }

  return /*#__PURE__*/React.createElement("a", {
    href: card.url,
    className: className,
    target: "_blank",
    rel: "noopener",
    ref: setRef,
    onClick: e => e.stopPropagation(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 252,
      columnNumber: 5
    }
  }, embed, description);
};

export default Card;